import { white, blue50, gray100, blue400 } from '@livechat/design-system-colors'

export const theme = {
  white,
  background: blue50,
  primary: blue400,
  secondary: gray100
};

export const navigationItem = {
  chats: 'Active chats',
  archive: 'Archive',
  agent: 'Agent details'
}

export const event_type = {
  filled_form: "filled_form",
  system_message: "system_message",
  message: "filled_form",
}